'use client';

import { useCustomer } from '@packages/shared/src/hooks/useCustomer/useCustomer';
import type { PostLoginAction } from './postLoginActions';
import { ChangeEmailClient } from '../Login/PostLoginChecks/ChangeEmail/ChangeEmail.client';

export interface ChangeEmailModalProps {
  action: PostLoginAction;
  onClose: () => void;
}

/**
 * Modal for handling the CHECK_EMAIL post-login action.
 * Displays the email change form from the existing Login module.
 */
export const ChangeEmailModal = ({ action: _action, onClose }: ChangeEmailModalProps) => {
  const { customer } = useCustomer();

  return <ChangeEmailClient customer={customer ?? null} hideHeadline={false} onClose={onClose} />;
};
